import * as React from 'react';
import { Stack } from './Stack.js';

function VStack(props) {
    return <Stack {...props} direction="vertical">{props.children}</Stack>;
}

export { VStack }